import { Button } from "@/components/ui/button";
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerHeader,
  DrawerTitle,
  DrawerTrigger,
} from "@/components/ui/drawer";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { languages } from "@/utils/i18n";

import { useTranslation } from "react-i18next";
import { setStoredLanguage } from "../utils";

export function LanguageSelector() {
  const { t, i18n } = useTranslation();

  const currentLanguage = i18n.language;

  const changeLanguage = async (language: string) => {
    await i18n.changeLanguage(language);
    await setStoredLanguage(language);
  };

  return (
    <Drawer>
      <DrawerTrigger asChild>
        <Button variant="outline">{t("settings.language.button")}</Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerHeader>
          <DrawerTitle>{t("settings.language.title")}</DrawerTitle>
          <DrawerDescription>
            {t("settings.language.description")}
          </DrawerDescription>
        </DrawerHeader>

        <RadioGroup
          defaultValue={currentLanguage}
          onValueChange={changeLanguage}
          className="grid gap-2 p-4 overflow-y-auto"
        >
          {languages.map((language) => (
            <div key={language.code} className="flex items-center">
              <RadioGroupItem
                value={language.code}
                id={language.code}
                className="peer hidden"
              />
              <Label
                htmlFor={language.code}
                className="flex rounded-md border-2 border-muted bg-popover p-4 peer-data-[state=checked]:border-primary peer-data-[state=checked]:bg-secondary [&:has([data-state=checked])]:border-primary w-full"
              >
                <span className="text-2xl mr-4">{language.flag}</span>
                <div className="flex flex-col gap-1">
                  <span className="font-medium text-[15px] text-slate-800 flex items-center gap-2">
                    {language.name}
                  </span>
                  <span className="text-sm text-slate-500/70">
                    {language.nativeName}
                  </span>
                </div>
              </Label>
            </div>
          ))}
        </RadioGroup>
      </DrawerContent>
    </Drawer>
  );
}
